import React, {
  useState,
} from 'react';

import {
  Icon,
  Button,
} from 'web-components';

import {
  Flex,
  H500,
  icons,
} from 'web-styled';

import * as S from './styled';

type Props = {
  video: any,
  assigned: boolean,
  assignedText: string,
  assignButton: string,
  onAssign: { (video: any): void },
};

const Video = ({
  video,
  assigned,
  assignedText,
  assignButton,
  onAssign,
}: Props) => {
  const [isPlaying, setPlay] = useState(false);
  return (
    <S.Video key={video.id}>
      <S.Preview
        flex="50%"
        style={{ backgroundImage: `url(${video.preview_picture_url})` }}
      >
        {isPlaying ? (
          <S.Frame
            src={`${video.embed_url}?autoplay=1`}
            allowFullScreen
          />
        ) : (
          <S.PlayIcon onClick={() => setPlay(true)} />
        )}
      </S.Preview>
      <S.Details>
        <H500>{video.name}</H500>
        <S.VideoType>
          {{
            youtube: (
              <Icon type="fab fa-youtube" />
            ),
            gymcloud: (
              <img src={icons.videoGymcloud} alt="" />
            ),
            library: (
              <img src={icons.videoLibrary} alt="" />
            ),
          }[video.type]}
          <span>{video.type}</span>
        </S.VideoType>
        <Flex width="100%" justify="center">
          {assigned ? (
            <Button
              appearance="primary"
            >
              {assignedText}
            </Button>
          ) : (
            <Button
              ghost
              appearance="primary"
              onClick={() => onAssign(video)}
            >
              {assignButton}
            </Button>
          )}
        </Flex>
      </S.Details>
    </S.Video>
  );
};

export default Video;
